module.exports = __webpack_public_path__ + "static/media/Vinted_logo.3dcf8b02.png";